export const ASSETPATH = {
    'images':'assets/images/',
    'svg': '.svg',
    'png': '.png'
}